<template>
  <section>
    <v-card v-if="!!datos_personales && !!estado_vacacion">
      <v-card-text class="contenedor-datos-personales">
        <div class="sub-contenedor-datos-personales">
          <v-layout row wrap justify-center align-center>
            <v-flex shrink>
              <v-avatar
                :color="foto ? '#FFF' : 'light-blue darken-4'"
                size="90"
              >
                <v-img
                  v-if="foto"
                  :aspect-ratio="16 / 9"
                  :src="foto"
                  max-height="200"
                  max-width="200"
                  min-height="75"
                  min-width="75"
                  @error="handleImageError()"
                >
                </v-img>
                <span v-else class="white--text display-1">{{
                  datos_personales.nombres.trim()[0] || "-"
                }}</span>
              </v-avatar>
            </v-flex>
            <v-flex shrink>
              <v-layout row wrap>
                <v-flex
                  v-for="(atributo, index) in atributos_persona"
                  xs12
                  :key="index"
                  class="datos-persona"
                >
                  <v-layout row wrap justify-center align-center>
                    <v-flex
                      xs12
                      md6
                      class="titulo text-md-right text-xs-center"
                      >{{ atributo.label }}</v-flex
                    >
                    <v-flex
                      xs12
                      md6
                      class="contenido text-md-left text-xs-center"
                      >{{ atributo.value }}</v-flex
                    >
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
      <v-card-text class="pa-0">
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :headers="headers_saldos"
          :items="l_saldos_vacaciones"
          hide-actions
        >
          <template v-slot:items="props">
            <td class="text-xs-right">
              {{
                props.item.periodo == estado_vacacion.periodo
                  ? `Saldo a ganar en el periodo ${props.item.periodo - 1} - ${
                      props.item.periodo
                    }`
                  : `Saldo periodo  adquirido ${props.item.periodo - 1} - ${
                      props.item.periodo
                    }`
              }}
            </td>
            <td class="text-xs-center">{{ props.item.dias_saldo }}</td>
            <td class="text-xs-center">{{ props.item.dias_programar }}</td>
            <td class="text-xs-center">
              {{ props.item.dias_saldo - props.item.dias_programar }}
            </td>
            <td class="text-xs-center font-weight-bold">
              {{
                `Podrán ser programados desde el ${$moment(
                  props.item.fecha_inicio_uso
                ).format("DD/MM/YYYY")} al ${$moment(
                  props.item.fecha_fin_uso
                ).format("DD/MM/YYYY")}`
              }}
            </td>
          </template>
          <template v-slot:footer>
            <tr>
              <td colspan="2" class="footer-table">
                <strong>{{
                  `Total días a programar de acuerdo a porcentaje (${datos_programacion.porcentaje}%)`
                }}</strong>
              </td>
              <td class="text-xs-center title">
                <strong>{{ total_dias_programar }}</strong>
              </td>
            </tr>
            <tr style="height: 10px;">
              <td colspan="5" class="caption">
                {{
                  `*Los DÍAS NO PROGRAMADOS podrán ser utilizados a través de "Solicitud con Cargo a Vacación"`
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  props: {
    id_estado_vacacion: {
      type: Number,
      default: null
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      estado_vacacion: null,
      datos_programacion: null,
      datos_personales: null,
      l_saldos_vacaciones: [],
      headers_saldos: [],
      api_backend: process.env.API_URL.split("api/")[0],
      foto: "",
      atributos_persona: []
    };
  },
  computed: {
    total_dias_programar() {
      return this.l_saldos_vacaciones.reduce((accumulator, current) => {
        return accumulator + current.dias_programar;
      }, 0);
    }
  },
  async mounted() {
    // Obtenemos datos personales y de estado vacacion
    this.estado_vacacion = await this.$query.select(
      "v_estado_vacacion",
      { id: this.id_estado_vacacion },
      ["id_persona", "periodo", "id_programacion"]
    );
    this.estado_vacacion = this.estado_vacacion[0];
    // Obtenemos datos programacion de vacaciones
    this.datos_programacion = await this.$query.select(
      "programacion",
      { id: this.estado_vacacion.id_programacion },
      ["porcentaje"]
    );

    this.datos_programacion = this.datos_programacion[0];
    // Obtenemos datos de saldos de vacaciones
    this.l_saldos_vacaciones = await this.$query.select(
      "estado_vacacion_saldos",
      { id_estado_vacacion: this.id_estado_vacacion },
      [
        "fecha_inicio_uso",
        "fecha_fin_uso",
        "dias_saldo",
        "dias_programar",
        "periodo"
      ]
    );
    // Actualizamos v-model
    this.updateValue();
    // Obtenemos los datos personales de la persona
    this.datos_personales = await this.$query.select(
      "v_datos_personales_programacion",
      { id_estado_vacacion: this.id_estado_vacacion },
      [
        "id_estado_vacacion",
        "periodo",
        "id_persona",
        "ap_paterno",
        "ap_materno",
        "nombres",
        "nro_doc",
        "foto",
        "nro_item",
        "fecha_incorporacion",
        "cas"
      ]
    );
    this.datos_personales = this.datos_personales[0];
    if (this.datos_personales.foto) {
      this.foto = this.api_backend + this.datos_personales.foto;
    } else {
      this.foto = "";
    }
    // Constuimos headers
    (this.headers_saldos = [
      { text: "", value: "periodo", align: "center", sortable: true },
      {
        text: "Cantidad de dias",
        value: "",
        align: "center",
        sortable: false
      },
      {
        text: `Dias a programar de acuerdo a porcentaje (${this.datos_programacion.porcentaje}%)`,
        value: "",
        align: "center",
        sortable: false
      },
      {
        text: "Dias no programados",
        value: "",
        align: "center",
        sortable: false
      },
      {
        text: "Nota a considerar",
        value: "",
        align: "center",
        sortable: false
      }
    ]),
      // Iteramos datos que se mostraran
      (this.atributos_persona = [
        {
          label: "NOMBRE: ",
          value: `${this.datos_personales.ap_paterno} ${this.datos_personales.ap_materno} ${this.datos_personales.nombres}`
        },
        {
          label: "FECHA DE INCORPORACIÓN: ",
          value: this.$moment(this.datos_personales.fecha_incorporacion).format(
            "DD/MM/YYYY"
          )
        },
        {
          label: "ITEM: ",
          value: this.datos_personales.nro_item
        },
        {
          label: "CAS: ",
          value: this.datos_personales.cas
        }
      ]);
  },
  methods: {
    updateValue() {
      // Emitir un nuevo valor cuando se necesite actualizar
      this.$emit("input", this.total_dias_programar);
    },
    handleImageError() {
      this.foto = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.datos-persona {
  display: flex;
  .titulo {
    color: rgb(187, 227, 250);
    font-weight: 700;
    font-size: 1.1rem;
    padding: 0rem 0.25rem;
  }
  .contenido {
    color: rgba(255, 255, 255, 0.8);
    font-weight: 600;
    padding: 0rem 0.25rem;
  }
}
.contenedor-datos-personales {
  background-image: url(../../../../assets/images/profile.png);
  background-color: white;
  background-position: center;
  background-size: cover;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  position: -webkit-sticky;
  position: sticky !important;
  padding: 0rem;
  // top: 4.8rem;
  // z-index: 2;
  .sub-contenedor-datos-personales {
    background-color: rgba(0, 92, 167, 0.699);
    padding: 0.5rem 2rem;
  }
}
.footer-table {
  background-color: rgba(0, 92, 167, 0.699);
  color: rgba(255, 255, 255, 1);
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacaciones/components/DatosPersonalesProgramacion.vue